import { OutgoingMailDTO } from "../../models/outgoing-mail/outgoing-mail-dto";
import { OutgoingMailSTO } from "../../models/outgoing-mail/outgoing-mail-sto";
import { BaseApiService } from "../base";

export class OutgoingMailApiService extends BaseApiService<OutgoingMailDTO, OutgoingMailSTO> {
  constructor() {
    super({
      servicePath: "/OutgoingMail",
      loadItemsPath: "/GetOutgoingMails",
      saveItemsPath: "/SaveOutgoingMails",
    });
  }
}
